<template>
  <Poptip trigger="click" padding="0" >
    <Tooltip content="帮助">
      <CIcon size="18" icon="zhuangtai-bangzhu" class="rtop-down-icon"></CIcon>
    </Tooltip>
    <template v-slot:content>
      <div class="rtop-down-box">
        <!-- <a class="rtop-down-boxli" :href="softDownUrl">下载软电话</a> -->
        <div class="rtop-down-boxli" @mouseenter="appImgShow = true" @mouseleave="appImgShow = false">
          <span>下载APP</span>
        </div>
      </div>
      <div class="rtop-down-appimg" v-show="appImgShow">
        <img :src="http" alt="下载APP" />
      </div>
    </template>
  </Poptip>
</template>
<script>
import envConst from '@/env-const'
export default {
  name: 'noticeCenterEntrance',
  data() {
    return {
      appImgShow: false,
      iconTip: false,
      // softDownUrl: envConst.API_BASE_URL +'/sipphone/sipphone.zip',
      // softDownUrl: 'https://newim.xxx.xx/sipdownload/sipphone.zip'
      softDownUrl: envConst.SIP_BASE_URL +'/sipphone.zip',
      http:''
    }
  },
  created() {
    this.http = envConst.SCMCC_HOST+'/images/app-QRCode.png'
  },
  methods: {
  }
}
</script>
<style scoped>
.rtop-down-icon {
  margin-top: 3px;
}
.rtop-down-icon:hover,
.rtop-down-icon:active {
  color: #04cbdb;
}
.rtop-down-box {
  text-align: left;
  list-style: none;
  padding: 10px 0 5px 0;
  position: relative;
}
.rtop-down-boxli {
  display: block;
  width: 100%;
  line-height: 30px;
  padding: 0 15px;
  cursor: pointer;
  color: #515a6e;
}
.rtop-down-boxli:hover,
.rtop-down-boxli:active {
  background: #f1f7f7;
  color: #00b8c4;
}
.rtop-down-boxli-spe {
  position: relative;
  z-index: 2;
}
.rtop-down-appimg {
  position: absolute;
  top: 50px;
  left: 150px;
  z-index: 3;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0px 2px 8px rgba(0,0,0,.2);
  width: 100px;
  height: 100px;
  overflow: hidden;
}
.rtop-down-appimg img {
  display: inline-block;
  width: 100px;
  height: 100px;
  padding: 5px;
}
</style>
